import {inject} from '@angular/core';
import {CanActivateFn} from '@angular/router';
import {environment} from '../../../environments/environment';
import {AuthStore} from '../store/auth.store';

export const roleGuard: CanActivateFn = (route, state) => {
  const authStore = inject(AuthStore);

  const user = authStore.user();

  if (!user) {
    // User is not logged in at all
    window.location.assign(environment.authUrl);
    return false;
  }

  // Get the role required for this route from the route data
  // Default to requiring 'admin' if no specific role is defined
  const requiredRole = route.data?.['role'] || 'admin';

  // Check if the user has the required role
  // We check user.roles or fallback to checking user.user_type
  const hasRole = user.role === requiredRole || requiredRole.includes(user.user_type);

  if (hasRole) {
    return true;
  }

  // User lacks required roles. Redirect to auth without logging out;
  // auth's guestGuard will route them to their designated portal.
  window.location.assign(environment.authUrl);
  return false;
};
